import springApi from '../../services/springApi'

export const getVisitsReport = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/reports/visits', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getTaskResponsesUserReport = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/reports/task_responses_user', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)